export class Answer {
  constructor(
    private id: AnswerId,
    public content: string,
    public correct: boolean,
    public order: number,
    public value: number
  ) { }
}

export type AnswerId = string;



// WEBPACK FOOTER //
// /dist/src/app/question/answer.model.ts